import script from "./StepLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepLayout.vue?vue&type=script&setup=true&lang=ts"

import "./StepLayout.vue?vue&type=style&index=0&id=11cddaa0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11cddaa0"]])

export default __exports__